<header>
  <div id="logo-container">
    <a id="logo" [routerLink]="['/partners', 'my-profile']">
      <img src="assets/img/logo/logo-bisual-black.png" alt="bisual" />
      <span id="logo-subtitle">Partners</span>
    </a>
  </div>
  <div id="header-menu-container">
    <button mat-icon-button (click)="showHeaderMenu = !showHeaderMenu" id="toggle-menu-header">
      @if (!showHeaderMenu) {
        <mat-icon>expand_more</mat-icon>
      }
      @if (showHeaderMenu) {
        <mat-icon>expand_less</mat-icon>
      }
    </button>
    <div id="header-menu-content" [ngClass]="{ show: showHeaderMenu }">
      <button id="account-button" mat-stroked-button [matMenuTriggerFor]="account_menu">
        <img class="account-button-avatar" [src]="me.profile_picture_url" alt="" />
        <span id="me-container">
          <span class="me-name-row">
            @if (has_pending_slack()) {
              <span class="account-pending-dot" aria-hidden="true"></span>
            }
            <span class="me-name">{{ me.name + ' ' + me.surnames }}</span>
          </span>
          @if (me.company) {
            <span class="company"> Partner - {{ me.company.fact_name }} </span>
          }
        </span>

        <mat-icon iconPositionEnd>expand_more</mat-icon>
      </button>

      <mat-menu #account_menu="matMenu" xPosition="before">
        <a mat-menu-item [routerLink]="['partners', 'my-profile']" class="account-menu-profile-item">
          <mat-icon>account_circle</mat-icon>
          <span>Mi cuenta</span>
          @if (has_pending_slack()) {
            <span class="account-pending-dot account-pending-dot--menu" aria-hidden="true"></span>
          }
        </a>
        @if (parentUser != null) {
          <button mat-menu-item (click)="desimpersonar()">
            <mat-icon>keyboard_return</mat-icon>
            Desimpersonar
          </button>
        }

        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          Cerrar sesión
        </button>
      </mat-menu>
    </div>
  </div>
</header>
